import IMG_STEP_1 from 'assets/images/online-booking/stripe-step-1.png';
import IMG_STEP_2 from 'assets/images/online-booking/stripe-step-2.png';
import IMG_STEP_3 from 'assets/images/online-booking/stripe-step-3.png';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import ExternalLink from 'components/generic/ExternalLink.component';
import Icon from 'components/generic/Icon.component';
import Space from 'components/generic/Space.component';
import BULLET_POINTS from 'constants/bulletPoints.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './AfterEnableVoucherModal.module.scss';

const AfterEnableVoucherModal = ({ isOpen, dashboardLink, onReject, onDashboardLink }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="AfterEnableVoucherModal" isOpen={isOpen} variant="large" banner="empty">
      <SalonModal.Body>
        <div className={CN.scroll}>
          <div className={CN.modalImage}>
            <div className={CN.iconContainer}>
              <Icon variant="alert" />
            </div>
          </div>
          <div className={CN.modalContent}>
            <div className={CN.modalTitle}>{t('onlineBooking.eVauchers.enabledVoucherModal.title')}</div>
            <div className={CN.modalSubTitle}>
              {t('onlineBooking.eVauchers.enabledVoucherModal.descriptionPart1')}
              <Space>
                <div className={CN.textBold}>{t('onlineBooking.eVauchers.enabledVoucherModal.descriptionPart2')}</div>
              </Space>
              {t('onlineBooking.eVauchers.enabledVoucherModal.descriptionPart3')}
              <Space>
                <div className={CN.textBold}>{t('onlineBooking.eVauchers.enabledVoucherModal.descriptionPart4')}</div>
              </Space>
              {t('onlineBooking.eVauchers.enabledVoucherModal.descriptionPart5')}
              <Space>
                <div className={CN.textBold}>{t('onlineBooking.eVauchers.enabledVoucherModal.descriptionPart6')}</div>
              </Space>
              {t('onlineBooking.eVauchers.enabledVoucherModal.descriptionPart7')}
              <Space>
                <div className={CN.textBold}>{t('onlineBooking.eVauchers.enabledVoucherModal.descriptionPart8')}</div>
              </Space>
            </div>
            <div className={CN.textAlert}>{t('onlineBooking.eVauchers.enabledVoucherModal.warningText')}</div>
            <div className={CN.modalText}>
              <div className={CN.item}>
                <div className={CN.number}>{BULLET_POINTS.one}</div>
                <div>
                  <div className={CN.textBold}>{t('onlineBooking.eVauchers.enabledVoucherModal.stepOne')}</div>
                  <Space>{t('onlineBooking.eVauchers.enabledVoucherModal.stepOneText')}</Space>
                </div>
              </div>
              <img
                src={IMG_STEP_1}
                alt={t('onlineBooking.eVauchers.enabledVoucherModal.stepOneAlt')}
                className={CN.imgSteps}
              />
              <div className={CN.item}>
                <div className={CN.number}>{BULLET_POINTS.two}</div>
                <div>
                  <div className={CN.textBold}>{t('onlineBooking.eVauchers.enabledVoucherModal.stepTwo')}</div>
                  <Space>{t('onlineBooking.eVauchers.enabledVoucherModal.stepTwoText')}</Space>
                </div>
              </div>
              <img
                src={IMG_STEP_2}
                alt={t('onlineBooking.eVauchers.enabledVoucherModal.stepTwoAlt')}
                className={CN.imgSteps}
              />
              <div className={CN.item}>
                <div className={CN.number}>{BULLET_POINTS.three}</div>
                <div>
                  <div className={CN.textBold}>{t('onlineBooking.eVauchers.enabledVoucherModal.stepThree')}</div>
                  <Space>{t('onlineBooking.eVauchers.enabledVoucherModal.stepThreeText')}</Space>
                </div>
              </div>
              <img
                src={IMG_STEP_3}
                alt={t('onlineBooking.eVauchers.enabledVoucherModal.stepThreeAlt')}
                className={CN.imgSteps}
              />
            </div>
          </div>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="outlineForce" onClick={onReject}>
          <span className={CN.buttonSpace}>{t('onlineBooking.eVauchers.enabledVoucherModal.doLaterButton')}</span>
        </Button>

        <ExternalLink link={dashboardLink} variant="secondary" onClick={onDashboardLink}>
          <span className={CN.buttonSpace}>{t('onlineBooking.eVauchers.enabledVoucherModal.loginStripe')}</span>
        </ExternalLink>
      </SalonModal.Footer>
    </SalonModal>
  );
};

export default AfterEnableVoucherModal;
